import { NgModule } from '@angular/core';
import { CommonModule, DatePipe, NgClass } from '@angular/common';
import { PatientDetailComponent } from './patient-detail/patient-detail.component';
import { PatientListComponent } from './patient-list/patient-list.component';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { PatientApprovedComponent } from './patient-list/patient-approved/patient-approved.component';
import { PatientPendingComponent } from './patient-list/patient-pending/patient-pending.component';
import { PatientRejectedComponent } from './patient-list/patient-rejected/patient-rejected.component';
import {
  PatientDeletionRequestComponent
} from './patient-list/patient-deletion-request/patient-deletion-request.component';
import { RouterModule } from "@angular/router";
import { PatientDetailVisitsComponent } from './patient-detail/patient-detail-visits/patient-detail-visits.component';
import {
  PatientDetailExpensesComponent
} from './patient-detail/patient-detail-expenses/patient-detail-expenses.component';
import {
  PatientDetailAdditionalComponent
} from './patient-detail/patient-detail-additional/patient-detail-additional.component';
import { PatientDetailNotesComponent } from './patient-detail/patient-detail-notes/patient-detail-notes.component';
import {
  PatientDetailChangeLogComponent
} from './patient-detail/patient-detail-change-log/patient-detail-change-log.component';
import {
  PatientVisitDetailComponent
} from './patient-detail/patient-detail-visits/patient-visit-detail/patient-visit-detail.component';
import { DragDropModule } from "@angular/cdk/drag-drop";
import { LightboxModule } from "ngx-lightbox";
import {
  PatientDetailActivityComponent
} from './patient-detail/patient-detail-activity/patient-detail-activity.component';
import { MomentModule } from "ngx-moment";
import { ClipboardModule } from "@angular/cdk/clipboard";
import { PatientPaymentInfoComponent } from './patient-detail/patient-payment-info/patient-payment-info.component';
import { PatientFeedbackComponent } from "./patient-list/patient-feedback/patient-feedback.component";
import {
  PatientFeedbackRowComponent
} from './patient-list/patient-feedback/patient-feedback-row/patient-feedback-row.component';
import { SharedModule } from "../../shared/shared.module";
import {
  PatientBankCoverFeeComponent
} from './patient-detail/patient-payment-info/patient-bank-cover-fee/patient-bank-cover-fee.component';
import { NgxMaskModule } from 'ngx-mask';
import { ExpenseModule } from '../expense/expense.module';
import { VisitModule } from "../visit/visit.module";
import { PatientRegisterComponent } from './patient-register/patient-register.component';
import { PatientRegistrationsComponent } from './patient-list/patient-registrations/patient-registrations.component';
import { CoreModule } from "../../core/core.module";
import { NgxSkeletonLoaderModule } from "ngx-skeleton-loader";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatInputModule } from "@angular/material/input";
import { NgxMatInputTelComponent } from "ngx-mat-input-tel";
import { PatientDiaryComponent } from "./patient-detail/patient-diary/patient-diary.component";
import { DiaryConfigModalComponent } from "./patient-detail/diary-config-modal/diary-config-modal.component";
import {
  BeneficiariesListModalComponent
} from './patient-detail/patient-payment-info/beneficiaries-list-modal/beneficiaries-list-modal.component';
import { MatRadioModule } from '@angular/material/radio';
import { MatExpansionModule } from '@angular/material/expansion';
import { ButtonComponent } from "../../shared/button/button.component";
import { SplitButtonComponent } from "../../shared/split-button/split-button.component";
import { PgoCallout } from "../../shared/pgo-callout/pgo-callout";
import { CheckboxComponent } from "../../shared/checkbox/checkbox.component";
import { PatientSetPasswordModalComponent } from "./patient-set-password-modal/patient-set-password-modal.component";
import { PatientDocumentsComponent } from "./patient-detail/patient-documents/patient-documents.component";
import { PatientLoginInfoComponent } from "./patient-detail/patient-login-info/patient-login-info.component";
import { PatientEdiariesComponent } from "./patient-detail/patient-ediaries/patient-ediaries.component";
import { EdiaryConfigModalComponent } from "./patient-detail/ediary-config-modal/ediary-config-modal.component";
import {
  PatientEdiaryEntryModalComponent
} from "./patient-detail/patient-ediaries/patient-ediary-entry-modal/patient-ediary-entry-modal.component";
import {
  PaymentInfoGeneralSettingsComponent
} from './patient-detail/patient-payment-info/payment-info-general-settings/payment-info-general-settings.component';
import {
  PaymentInfoCaxtonCardComponent
} from './patient-detail/patient-payment-info/payment-info-caxton-card/payment-info-caxton-card.component';
import {
  PaymentInfoCaxtonBankComponent
} from './patient-detail/patient-payment-info/payment-info-caxton-bank/payment-info-caxton-bank.component';
import {
  ConfirmWalletAssignmentModalComponent
} from './patient-detail/patient-payment-info/payment-info-caxton-card/confirm-wallet-assignment-modal/confirm-wallet-assignment-modal.component';
import {
  CardAlreadyActiveModalComponent
} from './patient-detail/patient-payment-info/payment-info-caxton-card/card-already-active-modal/card-already-active-modal.component';
import {
  GrantOnlineAccessToCaxtonComponent
} from './patient-detail/patient-payment-info/payment-info-caxton-card/grant-online-access-to-caxton/grant-online-access-to-caxton.component';
import {
  UpdateDiaryEntryModalComponent
} from "./patient-detail/patient-diary/update-diary-entry-modal/update-diary-entry-modal.component";
import { PatientApproveModalComponent } from "./patient-approve-modal/patient-approve-modal.component";
import {
  PaymentInfoNmibleCardComponent
} from './patient-detail/patient-payment-info/payment-info-nmible-card/payment-info-nmible-card.component';
import {
  PaymentInfoNmibleBankComponent
} from './patient-detail/patient-payment-info/payment-info-nmible-bank/payment-info-nmible-bank.component';
import {
  HighnoteCardViewerComponent
} from './patient-detail/patient-payment-info/payment-info-nmible-card/highnote-card-viewer/highnote-card-viewer.component';
import {
  CallModalComponent
} from './patient-detail/patient-detail-visits/patient-visit-detail/call-modal/call-modal.component';
import { AcsCallComponent } from '../../shared/acs-call/acs-call.component';
import { VideoPlayerModalComponent } from '../../shared/video-player-modal/video-player-modal.component';

@NgModule({
  declarations: [
    PatientDetailComponent,
    PatientListComponent,
    PatientApprovedComponent,
    PatientPendingComponent,
    PatientRejectedComponent,
    PatientDeletionRequestComponent,
    PatientDetailVisitsComponent,
    PatientDetailExpensesComponent,
    PatientDetailAdditionalComponent,
    PatientDetailNotesComponent,
    PatientDetailChangeLogComponent,
    PatientVisitDetailComponent,
    PatientDetailActivityComponent,
    PatientPaymentInfoComponent,
    PatientFeedbackComponent,
    PatientFeedbackRowComponent,
    PatientBankCoverFeeComponent,
    PatientRegisterComponent,
    PatientRegistrationsComponent,
    PatientDiaryComponent,
    BeneficiariesListModalComponent,
    DiaryConfigModalComponent,
    PatientEdiariesComponent,
    EdiaryConfigModalComponent,
    PatientEdiaryEntryModalComponent,
    PatientSetPasswordModalComponent,
    PatientDocumentsComponent,
    PatientLoginInfoComponent,
    PaymentInfoGeneralSettingsComponent,
    PaymentInfoCaxtonCardComponent,
    PaymentInfoCaxtonBankComponent,
    PaymentInfoNmibleCardComponent,
    PaymentInfoNmibleBankComponent,
    ConfirmWalletAssignmentModalComponent,
    CardAlreadyActiveModalComponent,
    GrantOnlineAccessToCaxtonComponent,
    UpdateDiaryEntryModalComponent,
    PatientApproveModalComponent,
    HighnoteCardViewerComponent,
    CallModalComponent
  ],
  imports: [
    LightboxModule,
    CommonModule,
    FormsModule,
    SharedModule,
    ReactiveFormsModule,
    RouterModule,
    DragDropModule,
    MatAutocompleteModule,
    MatInputModule,
    MatRadioModule,
    MatExpansionModule,
    MomentModule,
    ClipboardModule,
    NgxMaskModule,
    ExpenseModule,
    VisitModule,
    CoreModule,
    NgxSkeletonLoaderModule,
    NgxMatInputTelComponent,
    DatePipe,
    ButtonComponent,
    SplitButtonComponent,
    PgoCallout,
    CheckboxComponent,
    ReactiveFormsModule,
    ReactiveFormsModule,
    DatePipe,
    NgClass,
    ReactiveFormsModule,
    AcsCallComponent,
    VideoPlayerModalComponent
  ]
})
export class PatientModule { }
